import gsap from 'gsap';
import toArray from '../../helpers/toArray';
import timeoutPromise from '../../helpers/timeoutPromise';

export default {
  namespace: 'agenda',

  enter() {
    const timeline = document.querySelector('.grid');

    if (timeline) {
      const timelineItems = toArray(timeline.querySelectorAll('.agendaLineItem'));

      gsap.set(timeline, {
        x: 20,
        opacity: 0,
      });

      gsap.set(timelineItems, {
        x: 20,
        opacity: 0,
      });

      gsap.to(timeline, {
        x: 0,
        opacity: 1,
        duration: 1,
        ease: 'power1.out',
      })
        .then(() => (
          gsap.to(timelineItems, {
            x: 0,
            opacity: 1,
            stagger: 0.2,
            duration: 1,
            ease: 'power1.out',
          })
        ));

      return timeoutPromise(400);
    }

    return Promise.resolve();
  },
};
